<template>
    <div class="list bg-white">
        <div class="f-b-c">
            <div class="bg-white f--c">
                <el-select placeholder="请选择活动类型" style="width: 160px;margin-right: 14px" v-model="searchParams.type" clearable>
                    <el-option label="折扣活动" :value="2"></el-option>
                    <el-option label="限时促销活动" :value="1"></el-option>
                    <el-option label="节日促销活动" :value="3"></el-option>
                </el-select>
                <el-input style="width: 200px;" placeholder="请输入活动名称" v-model="searchParams.searchContent"></el-input>
                <el-popover placement="bottom" width="400" trigger="click" style="margin-left:14px">
                    <el-input v-model="searchParams.spuCodes" placeholder="SPU支持批量搜索" style="width:260px" clearable @change="resetPage" slot="reference">
                    <el-button slot="append" icon="el-icon-search" @click="resetPage"></el-button>
                    </el-input>
                    <el-input v-model="searchParams.spuCodes" placeholder="以换行分隔，最多50个" type="textarea" style="width:100%" clearable @change="resetPage" :rows="6"></el-input>
                </el-popover>
                <el-button type="primary" @click="resetPage" style="margin: 0 10px;">搜索</el-button>
            </div>
            <div style="margin: 10px 0" class="f-e">
                <el-button type="primary" @click="$router.push('/operation/Promotion/add?mode=add')">创建活动</el-button>
            </div>
        </div>
        <section>
            <el-table
                :data="tableData"
                border
                height="100%"
                style="width: 100%">
                <el-table-column
                    prop="level"
                    align="center"
                    label="优先级">
                </el-table-column>
                <el-table-column
                    prop="discountId"
                    align="center"
                    label="折扣活动ID"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    prop="discountName"
                    align="center"
                    label="活动名称"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    label="活动时间"
                    align="center"
                    min-width="150">
                    <template slot-scope="scope">
                        <div>开始时间: {{ scope.row.startTime | dateFormat }}</div>
                        <div>结束时间: {{ scope.row.endTime | dateFormat }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="促销类型">
                    <template slot-scope="scope">
                        {{ typeMap[scope.row.type] }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="优惠项">
                    <template slot-scope="scope">
                        <template v-if="scope.row.type ===1">-</template>
                        <template v-else>
                            <div v-if="scope.row.discountRule === 1">{{ `${scope.row.discountPercent}%` }}</div>
                            <div v-else>{{ `USD ${scope.row.discountFixed}` }}</div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="productNum"
                    align="center"
                    label="商品数">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="活动状态">
                    <template slot-scope="scope">
                        {{ statusMap[scope.row.status] }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    width="120">
                    <template slot-scope="scope">
                        <section v-if="scope.row.status !== 0" >
                            <el-button @click="editRow(scope.row)" type="text" size="small" style="margin-right: 8px">编辑</el-button>
                            <el-popconfirm title="确定提前结束这个活动吗？" icon-color="red" @confirm="overRow(scope.row)">
                                <el-button slot="reference" type="text" size="small" style="color: red">提前结束</el-button>
                            </el-popconfirm>
                        </section>
                        <section v-else>
                            <el-button type="text" @click="viewDetail(scope.row)">详情</el-button>
                            <el-button type="text" @click="copy(scope.row)">复制</el-button>
                        </section>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <div class="f-e" style="margin-top:10px">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchParams.pageNumber"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import API from '@/api'
export default {
    props: {
        statusText: {
            type: String,
            default: () => '全部'
        }
    },
    data() {
        return {
            tableData: [],
            searchParams: {
                pageSize: 20,
                pageNumber: 1,
                searchContent: undefined,
                type: undefined
            },
            total: 0
        }
    },
    computed: {
        status() {
            const statusMap = {
                '全部': undefined,
                '未开始': 2,
                '进行中': 1,
                '已结束': 0
            }
            return statusMap[this.statusText]
        },
        typeMap() {
            const typeMap = {
                1: '秒杀活动',
                2: '折扣活动',
                3: '节日促销'
            }
            return typeMap
        },
        statusMap() {
            const statusMap = {
                2: '未开始',
                1: '进行中',
                0: '已结束'
            }
            return statusMap
        }
    },
    created() {
        const { statusText, ...other } = this.$store.state.promotionGetListParams
        if(statusText === this.statusText) this.searchParams = {...other}
    },
    methods: {
        editRow(row) {
            this.$router.push({
                path: '/operation/Promotion/add',
                query: {
                    id: row.id,
                    discountId: row.discountId,
                    mode: 'edit'
                }
            })
        },
        viewDetail(row) {
            this.$router.push({
                path: '/operation/Promotion/add',
                query: {
                    id: row.id,
                    discountId: row.discountId,
                    mode: 'readonly'
                }
            })
        },
        handleSizeChange(size) {
            this.searchParams.pageSize = size
            this.getList()
        },
        handleCurrentChange(page) {
            this.searchParams.pageNumber = page
            this.getList()
        },
        async getList() {
            try {
                const params = Object.assign({}, this.searchParams, {status: this.status})
                params.spuCodes = params.spuCodes ? params.spuCodes.split('\n') : undefined
                if (params.spuCodes && params.spuCodes.length > 50) {
                    this.$message("最多输入50行")
                    params.spuCodes.length = 50
                }
                this.$store.commit('setState', {key: 'promotionGetListParams', value: {...params, statusText: this.statusText}})
                const res = await API.promotionGetDiscountList(params)
                this.tableData = res.data.list
                this.total = res.data.total
            } catch (error) {
                this.$message.error(error.data)
            }
        },
        async overRow(row) {
            try {
                let res = await API.promotionDiscountStatusChange({id: row.id, status: 0, discountId: row.discountId})
                if(res.code !== 10000) {
                    this.$message.error(res.message || '操作失败')
                    return
                }
                this.$message.success('操作成功')
                this.getList()
            } catch (error) {
                this.$message.error(error.data)
            }
        },
        resetPage() {
            this.searchParams.pageNumber = 1
            this.getList()
        },
        copy(row) {
            this.$router.push({
                path: '/operation/Promotion/add',
                query: {
                    id: row.id,
                    discountId: row.discountId,
                    mode:'copy'
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.list {
    >section {
        height: calc(100vh - 245px);
    }
}
</style>